import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  // You can provide the target selector using Stimulus’s value API:
  // <div data-controller="cartzilla--binded-label"
  //      data-cartzilla--binded-label-target-selector-value="#colorOption"
  //      data-action="click->cartzilla--binded-label#updateLabel">
  static values = {
    targetSelector: String
  };

  connect() {
    // Use the value from Stimulus if provided, otherwise fall back to the legacy attribute.
    const selector = this.hasTargetSelectorValue
      ? this.targetSelectorValue
      : this.element.dataset.bindedLabel;

    this.targetElement = document.querySelector(selector);
    if (!this.targetElement) {
      console.error(`Target element not found for selector: ${selector}`);
      return;
    }

    // Check if a radio button is initially checked and update the target text.
    const checkedRadio = this.element.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      const matchedLabel = this.element.querySelector(`label[for="${checkedRadio.id}"]`);
      if (matchedLabel && matchedLabel.dataset.label) {
        this.targetElement.textContent = matchedLabel.dataset.label;
      }
    }
  }

  // This action is triggered when any element inside the controller is clicked.
  updateLabel(event) {
    // Find the closest element with a data-label attribute.
    const labelElement = event.target.closest('[data-label]');
    if (!labelElement) return;
    this.targetElement.textContent = labelElement.dataset.label;
  }
}
